import { useState } from 'react'
export default function TextDocument({ label, text, code = false }: { label: string; text: string; code?: boolean }) {
  const [status, setStatus] = useState('')
  async function copy() { try { await navigator.clipboard.writeText(text); setStatus('Copied') } catch { setStatus('Copy unavailable; select the text to copy.') } }
  return <section className={`text-document${code ? ' code-document' : ''}`} aria-label={label}>
    <div className="document-label"><strong>{label}</strong><button type="button" onClick={() => { void copy() }}>Copy</button></div>
    <pre>{text}</pre>{status && <p className="document-status" role="status">{status}</p>}
  </section>
}
